import jsPDF from "jspdf";
import employeeLogo from "../../images/employee.png";
import Arabic from "../../images/arabic title.png";
import { convertToRFT } from "../../utils/convertToRFT";
import { BoxesPacking } from "../features/BoxesPacking";
import WarehousePrint from "./WarehousePrint";
import address from "../../images/arabic address.png";
import html2pdf from "html2pdf.js";
import { Balance } from "@mui/icons-material";
import React from "react";
function StandardUserPrint({
  billNumber = "",
  customer = "",
  items = "",
  discount = "0",
  discountType = "",
  date = "",
  subTotal = "",
  Total = "",
  paid = "",
  formallyOutstandings = "0",
  saleType = "",
  notes = "",
  printQuote,
  Quote = "",
  fivePercent = "",
  gst = 0,
  gstType = "",
  varTotal,
  income = "0",
  further = "0",
}) {
  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  let imgSrc = baseUrl ;
  console.log("img", imgSrc);
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");

  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/(\d+[\.\-])\s+/g, "\n$1 ");

  console.log("b items", items);

  let totalQty = 0;
  let itemsUnit = items.find((item) => {
    return item.unit !== "";
  });
  const itemUnitString = itemsUnit?.unit || "";

  console.log("item", itemsUnit);
  let itemsSaleType = items.map((item, i) => {
    return item.saleType;
  });
  console.log("itemSaleType", itemsSaleType);

  const result = itemsSaleType.join("");
  console.log("result", result);
  let TotalQuantityBoxes;
  let TotalQuantityPieces;
  let TotalQuantityUnits;
  TotalQuantityPieces = items.reduce((acc, curr) => {
    let total;
    if (
      (curr.saleType == "pieces" && curr.unit == "pieces") ||
      (curr.saleType == "pieces" && curr.unit == "")
    ) {
      total = acc + curr.saleQuantity;
    } else {
      total = acc;
    }
    return total;
  }, 0);

  TotalQuantityBoxes = items.reduce((acc, curr) => {
    let total;
    if (curr.saleType == "box" && curr.unit == "") {
      total = acc + Number(curr.saleQuantity);
      console.log("current", curr.saleQuantity);
    } else {
      console.log("else", total);

      total = acc;
    }
    console.log();
    return total;
  }, 0);

  TotalQuantityUnits = items.reduce((acc, curr) => {
    let total;
    if (curr.unit !== "") {
      total = acc + Number(curr.saleQuantity);
      console.log("current", curr.saleQuantity);
    } else {
      total = acc;
    }
    console.log();
    return total;
  }, 0);
  console.log("itemsssssss", items);

  console.log("pieestol", TotalQuantityPieces);
  console.log("piebox", TotalQuantityBoxes);

  let rows = items
    .map((item, i) => {
      console.log("item", item);
      let { saleQty, itemPrice, totalPrice, discountAmount, itemDiscount } =
        convertToRFT(saleType, item, "", fivePercent);
      totalQty += parseInt(saleQty);
      let text;
      if (item.unit !== "pieces" && item.unit !== "") {
        text = "left !important";
        console.log("elseif");
      } else {
        text = "right !important";
        console.log("else");
      }
      return `
    <tr style="height:25px">
      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 5%; border: 2px solid #ccc;">${
        i + 1
      }</td>
      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 25%; border: 2px solid #ccc;">${
        item?.name
      }</td>
   
      <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 30%; border: 2px solid #ccc;">${item?.description}</td>
  

<td style="position: relative; font-family: 'Arial', sans-serif; font-size: 12px; font-weight: 600; width: 8%; padding-left: 10px; padding-right: 10px; border: 2px solid #ccc; text-align: ${text};">
  ${saleQty}
  <div style="position: absolute; top: 0; bottom: 0; left: 50%; width: 2px; background-color: #ccc;"></div>
</td>
       <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 8%; border: 2px solid #ccc;">${
         itemPrice % 1 == 0 ? itemPrice : itemPrice.toFixed(3)
       }</td>
      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 7%; border: 2px solid #ccc;">${itemDiscount}</td>
      <td style="font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 10%; border: 2px solid #ccc;">${discountAmount}</td>
      <td style=" font-family: 'Arial', sans-serif;font-size: 12px;font-weight:600;width: 17%; border: 2px solid #ccc">${
        totalPrice % 1 === 0 ? totalPrice : totalPrice.toFixed(3)
      }</td>
    </tr>`;
    })
    .join("");

  let htmlContent = `
  <div style="text-align: center;">
     ${imgSrc ? `
 <div style="display: flex; align-items: center;">
   <hr style="flex-grow: 1; margin-left: 20px; border: 1px solid #ccc;" />
  <div style="display: flex; justify-content: start;">
   <img src="${imgSrc}" style="width: 200px; height: 200px;" /> 
  </div>
</div>
` : ""}

   <div style="display:flex;justify-content:center">
     <h1 style="font-size:15px;">${company}</h1>
    </div>

    <div style="display:flex;justify-content:flex-end;max-width:90%">
          <p style="font-size: 12px; font-weight: 600; margin: 4px;">Date</p>
          <p style="font-size: 12px; font-weight: 600; margin: 4px;">${date}</p>
        </div>
 
        
        <div style="margin-left:4rem">
         <div style="display:flex; margin-right: ${
   customer.match(/^.{9,}$/) ? "12px" : "2px"
 }">
     <p style="font-size: 12px;font-weight:600;margin:4px">Customer</p>
     <p style="font-size: 12px;font-weight:600;margin:4px;">${customer}</p>
   </div>

</div>

  <div style="display:flex;flex-direction:column;align-Items:center;>

     


    ${
      `
      <div style="">    
      </div>

    `
    }
    <table style=" text-align: center; margin:20px;margin-bottom:0; border-collapse: collapse;">
      <thead style="height:25px">
        <tr style="font-size: 12px;font-weight:1000; border: 1px solid black;">
          <th style="width: 5%; border: 2px solid #000000;">#</th>
          <th style="width: 25%; border: 2px solid #000000;">ITEM</th>
       
          <th style="width: 30%; border: 2px solid black;">Description</th>
  
            
 
  <th style="width: 8%; border: 2px solid black;">Qty</th>
  

              
          <th style="width: 8%; border: 2px solid black;">Price</th>
          <th style="width: 7%; border: 2px solid black;">Disc</th>
          <th style="width: 10%; border: 2px solid black;">Disc Amount</th>
          <th style="width: 17%; border: 2px solid black;">Total Price</th>
        </tr>
      </thead>
      <tbody style="border: 1px solid black;">
        ${rows}
      </tbody>
    </table>

    

   
<div style="display:flex;justify-content:flex-end;width:90%;margin-top:5rem;">



   
 <div>
  <div style="display: flex; width: 130px;color:black;font-weight:600;justify-content:space-between; font-size: 12px; margin-bottom: 0;">
    <p style="margin: 0;">Sub Total</p>
    <p style="margin: 0;">${
      Number(subTotal) % 1 === 0
        ? Number(subTotal)
        : Number(subTotal).toFixed(3)
    }</p>
  </div>



  <div style="display: flex; width: 130px;justify-content:space-between; font-size: 12px;font-weight:600; margin-bottom: 0;">
    <p style="margin: 0;">Discount</p>
    <p style="margin: 0;">${discount || 0}</p>
  </div>

  <div style="display: flex;width: 130px;justify-content:space-between; font-size: 12px;font-weight:600; margin-bottom: 0;">
    <p style="margin: 0;">Previous Balance</p>
    <p style="margin: 0;">${formallyOutstandings}</p>
  </div>

  <div style="display: flex; width: 130px;justify-content:space-between; font-size: 12px;font-weight:600; margin-bottom: 0;">
    <p style="margin: 0;">Total</p>
    <p style="margin: 0;">${
      Number(Total) % 1 === 0 ? Number(Total) : Number(Total).toFixed(3)
    }</p>
  </div>

  <div style="display: flex; width: 130px;justify-content:space-between; font-size: 12px;font-weight:600; margin-bottom: 0;">
    <p style="margin: 0;">Paid</p>
    <p style="margin: 0;">${
      Number(paid) % 1 === 0 ? Number(paid) : Number(paid).toFixed(3)
    }</p>
  </div>

  <div style="display: flex; width: 130px;justify-content:space-between; font-size: 12px;font-weight:600; margin-bottom: 0;">
    <p style="margin: 0;">Balance</p>
    <p style="margin: 0;">${
      Number(Total - paid) % 1 === 0
        ? Number(Total - paid)
        : Number(Total - paid).toFixed(3)
    }</p>
  </div>


</div>

  
</div>

   ${
     terms
       ? `
    <div style="display: flex; justify-content: center;">
      <p style="margin-top: 20px; font-size: 12px; text-align: center;">
     
        ${terms
          .replace(/\n/g, "<br>")
          .replace(/Phone\\s*no\\s*:\\s*\\d{11}(?:,\\d{11})*/g, "<br>$&")}
      </p>
    </div>
  `
       : ""
   }


     <div style="display: flex; flex-direction: column;gap:2rem;max-width:30%;margin-left:2rem;margin-top:2rem">

          <div style="display: flex; flex-direction: column;">

         <p style="margin: 0;font-weight:600">Address</p>
      <p style="font-size: 12px; font-weight: 600; margin: 4px;">
        ${address}
      </p>
    </div>


    <div style="display: flex; flex-direction: column;">
     <p style="margin: 0;font-weight:600">Contact</p>
      <p style="font-size: 12px; font-weight: 600; margin: 4px;">
        ${phone ? phone + " " : ""} 
        ${phone1 ? phone1 + " " : ""} 
        ${phone2 ? phone2 : ""}
      </p>
      </div>
    </div>

  </div>
`;

  let opt = {
    margin: 0,
    filename: "receipt.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // A4 size in portrait
  };

  // html2pdf().from(htmlContent).set(opt).output('blob').then((blob) => {
  //   const url = URL.createObjectURL(blob);
  //   window.open(url, '_blank');
  // });}
  html2pdf()
    .from(htmlContent)
    .set(opt)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100); // Wait a second for the PDF to load before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default StandardUserPrint;
